// Paleta de DADOS dos graficos (series, categorias). Nao e cor de tema: a mesma serie
// tem a mesma cor no claro e no escuro, senao o usuario perde a referencia ao trocar.
// Por isso este arquivo esta em scripts/theme-allowlist.txt.
//
// Cor de tema dos graficos (texto, eixo, fundo, tooltip) vem dos tokens --chart-* de
// src/utils/styles/theme.scss, lidos pelo ChartTheme.
export const chartColors = [
    '#3b82f6',
    '#f5a524',
    '#6366f1',
    '#10b981',
    '#8b5cf6',
    '#0ea5a4',
    '#a78bfa',
    '#ec4899',
    '#f97361',
    '#78716c',
    '#ca8a04',
    '#5eead4',
]

// Base do degrade das colunas (chartColors[0] esmaecido)
export const chartColumnFade = 'rgba(59, 130, 246, 0.55)'

// Faixa do crosshair do eixo X (chartColors[0] quase transparente)
export const chartCrosshair = 'rgba(59, 130, 246, 0.06)'
